import React, { useEffect, useState } from 'react'
import TitleWithBackNavigation from '../../../../components/TitleWithBackNavigation'
import { Col, Pagination, Row } from 'antd'
import { useQuery } from 'react-query'
import axiosInstance from '../../../../config/api'
import Circular from '../../../../components/Loader/Circular/Circular'
import FullPageLoader from '../../../../components/FullPageLoader'
import { formatTimestamp } from '../../../../config/utils/TimeFormatter'
import { useDispatch } from 'react-redux'
import { setAppLoading } from '../../../../store/common/generalSlice'
import { useNavigate } from 'react-router-dom'
import { transactionType } from '../../../../config/utils/constants'
import { statusIdentifier } from '../../../../config/utils/StatusIdentifier'


const getTransactionRecords = async (limit, offset) => {
    try {
        let res = await axiosInstance.get(`/stripe/transaction?limit=${limit}&offset=${offset}`);
        if (res?.status == 200) {
            return res?.data?.data?.transaction
        }
        else {
            return
        }
    } catch (error) {
        console.log(error)
        return
    }
}

// bookingStatus: {
//     PENDING: 0,
//     COMPLETED: 1,
//     REJECTED: 2,
//     ACCEPTED: 3,
//     INPROGRESS: 4,
//   },

const TransactionHistory = () => {

    const [state, setState] = useState({
        limit: 10,
        offset: 0,
        page: 1,
        total: 0,
        data: []
    })

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        let transactionRecords = async () => {
            dispatch(setAppLoading(true));
            const { count, rows } = await getTransactionRecords(state?.limit, state?.offset);
            setState({
                ...state,
                total: count,
                data: rows
            })
            dispatch(setAppLoading(false));
            return
        }
        transactionRecords()
    }, [state?.offset])


    const paginationHandler = (page, limit) => {
        let pageLimit = state?.limit
        let offset = (page * pageLimit) - pageLimit;
        setState({ ...state, page: page, offset: offset })
    }

    const TransactionDetailHandler = (id) => {
        navigate(`/settings/transaction/${id}`)
    }

    return (
        <div className='w-full'>
            <TitleWithBackNavigation title={'Transaction History'} link={'/settings'} />

            <Row className='w-full mt-3 overflow-x-scroll'>

                {/* // Columns heading */}
                <Row justify={'space-between'} className='min-w-[600px] sm:w-full bg-[#B1BBC9] px-3 py-3 font-semibold'>
                    <Col lg={4} md={4} sm={5} xs={5}>
                        <h3 className='w-full'>Date/Time</h3>
                    </Col>
                    <Col lg={3} md={3} sm={4} xs={4}>
                        <h3 className='w-full text-center sm:text-start'>Transaction ID</h3>
                    </Col>
                    <Col lg={3} md={3} sm={3} xs={3}>
                        <h3 className='w-full text-center sm:text-start'>Status</h3>
                    </Col>
                    <Col lg={3} md={3} sm={3} xs={3}>
                        <h3 className='w-full text-center sm:text-start'>Amount</h3>
                    </Col>
                    <Col lg={3} md={3} sm={3} xs={3}>
                        <h3 className='w-full'>Purpose</h3>
                    </Col>
                    <Col lg={4} md={4} sm={3} xs={3}>
                        <h3 className='w-full'>Type</h3>
                    </Col>
                    <Col lg={4} md={4} sm={3} xs={3}>
                        <h3 className='w-full'>Service Details</h3>
                    </Col>
                </Row>
                {/* // Data to be mapped against those columns */}
                {
                    state?.data?.length > 0 ? state?.data?.map((transaction) => {
                        let { status, colorClass } = statusIdentifier(transaction?.booking?.status)
                        return (
                            <Row justify={'space-between'} className='min-w-[600px] sm:w-full px-3 py-3 mt-1  border-b border-gray-300 border-dashed cursor-pointer' key={transaction?.id}>
                                <Col lg={4} md={4} sm={5} xs={5}>
                                    <h3 className='w-full pr-4'>{formatTimestamp(transaction?.updatedAt || transaction?.createdAt)}</h3>
                                </Col>
                                <Col lg={3} md={3} sm={4} xs={4}>
                                    <h3 className='text-center sm:text-start w-full'>{transaction?.id}</h3>
                                </Col>
                                <Col lg={3} md={3} sm={3} xs={3}>
                                    <span className={`break-all w-full text-center sm:text-start ${colorClass}`}>
                                        {status}
                                    </span>
                                </Col>
                                <Col lg={3} md={3} sm={3} xs={3}>
                                    <h3 className='font-semibold text-center sm:text-start w-full'>£ {transaction?.amount ? transaction?.amount.toFixed(2) : 0}</h3>
                                </Col>
                                <Col lg={3} md={3} sm={3} xs={3}>
                                    <h3 className='lowercase'>{transaction?.purpose}</h3>
                                </Col>
                                <Col lg={4} md={4} sm={3} xs={3}>
                                    <h3 className=''>{transactionType[transaction?.type] || transaction?.type}</h3>
                                </Col>
                                <Col lg={4} md={4} sm={3} xs={3}>
                                    <span className='py-2 px-5 bg-[#FAB700] text-white' onClick={() => TransactionDetailHandler(transaction?.bookingId)}>Detail</span>
                                </Col>
                            </Row>
                        )
                    })
                        :
                        <p className='w-full text-center my-4 font-semibold text-base'>No records found.</p>
                }
                {
                    state?.data?.length > 0 &&
                    <div className='my-3 w-full flex items-center justify-center'>
                        <Pagination
                            defaultCurrent={state?.page}
                            total={state?.total}
                            onChange={paginationHandler}
                        />
                    </div>
                }
            </Row>


        </div>
    )
}

export default TransactionHistory